import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  name: '',
  userType: '',
  freeScanUsed: false,
  environment: '',
  credits: 0, // Added credits field
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      return { ...state, ...action.payload };
    },
    clearUser(state) {
      return initialState;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
